import { Link, NavLink } from 'react-router-dom'

export default function Header() {
  return (
    <header className="header">
      <div className="header-inner container">
        <Link to="/" className="brand" aria-label="Zuchlag - Startseite">
          <img src="/logo.svg" alt="Zuchlag" className="brand-logo" />
        </Link>

        <nav className="nav" aria-label="Hauptnavigation">
          <NavLink to="/" end className={({ isActive }) => isActive ? 'nav-link is-active' : 'nav-link'}>
            Start
          </NavLink>
          <NavLink to="/suche" className={({ isActive }) => isActive ? 'nav-link is-active' : 'nav-link'}>
            Auktionen
          </NavLink>
        </nav>
      </div>
    </header>
  )
}
